import styled from 'styled-components'

export const CardSlill = styled.div`
    height: 128px;
    width: 224px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    border-radius: 15px;
    background:  rgb(17 24 39 / 1);

    margin: 10px;
`;